'use client';
import { memo, useState } from 'react';
import { VStack, Button, Collapse, Accordion, useDisclosure, Text } from '@chakra-ui/react';

import InterText from 'shared/InterText';
import { FaqItem } from './ui';

import { faqData } from 'constants/faq/faq';
import { DEFAULT_BORDER, DEFAULT_TRANSITION, EMPTY_OBJECT } from 'constants/global';

const ITEMS_GAP = '4px';

const FAQ = ({ maxVisibleItems = 5 }) => {
  const { isOpen, onToggle } = useDisclosure();
  const [activeIndex, setActiveIndex] = useState(-1);
  const isDataTruncated = faqData.length > maxVisibleItems;

  return (
    <VStack
      as="section"
      w="full"
      maxW="1040px"
      px={{ mobile: '16px', tablet: '20px' }}
      gap={{ mobile: '32px', tablet: '48px', laptop: '54px' }}
    >
      <Text as="h2" textAlign="center" color="ourWhite" textTransform="uppercase">
        Вопросы и ответы
      </Text>

      <VStack w="full" gap={{ mobile: '20px', laptop: '24px' }}>
        <Accordion
          index={activeIndex}
          allowToggle
          flex="1"
          w="full"
          display="flex"
          flexDirection="column"
        >
          <VStack w="full" gap={ITEMS_GAP}>
            {faqData.slice(0, maxVisibleItems).map((itemData, i) => (
              <FaqItem key={i} index={i} {...itemData} setActiveIndex={setActiveIndex} />
            ))}
          </VStack>

          {isDataTruncated && (
            <Collapse in={isOpen}>
              <VStack w="full" gap={ITEMS_GAP} pt={ITEMS_GAP}>
                {faqData.slice(maxVisibleItems).map((itemData, i) => (
                  <FaqItem
                    key={maxVisibleItems + i}
                    index={i}
                    maxVisibleItems={maxVisibleItems}
                    {...itemData}
                    setActiveIndex={setActiveIndex}
                  />
                ))}
              </VStack>
            </Collapse>
          )}
        </Accordion>

        {isDataTruncated && (
          <Button
            w="full"
            h="unset"
            p={{ mobile: '13px', laptop: '20px' }}
            borderRadius="32px"
            border={DEFAULT_BORDER}
            borderColor="ourWhite"
            color="ourWhite"
            bgColor="unset"
            transition={DEFAULT_TRANSITION}
            _active={EMPTY_OBJECT}
            _hover={{ bgColor: 'ourWhite', color: 'deepBlue' }}
            _focusVisible={{ bgColor: 'ourWhite', color: 'deepBlue' }}
            onClick={() => {
              onToggle();
              isOpen && activeIndex > maxVisibleItems && setActiveIndex(-1);
            }}
          >
            <InterText textStyle="b3">
              {isOpen ? 'Скрыть вопросы' : 'Смотреть больше вопросов'}
            </InterText>
          </Button>
        )}
      </VStack>
    </VStack>
  );
};

export default memo(FAQ);
